export default "__VITE_ASSET__CPClNwGU__"